<template>
  <article class="article-confirmation">
    <vs-row align="flex-start" justify="center" v-if="logo">
      <img class="logo" :src="logo_url"/>
    </vs-row>
    <vs-row align="center" justify="center" v-if="promoName">
      <h2>{{contentCopies.confirm_header}}</h2>
      <h3>{{contentCopies.confirm_body}}</h3>
    </vs-row>
    <vs-row align="center" justify="center" v-if="promoName">
      <vs-col align="center" justify="center" :lg="4" :sm="10" :xs="12">
        <vs-row align="center" justify="center">
          <img :src="prize.picture_url ? prize.picture_url : prize.picture" alt="prize logo" width="80%" />
        </vs-row>
        <vs-row align="center" justify="center">
          <h3>{{ prize.prizeName }}</h3>
        </vs-row>
      </vs-col>
      <vs-col
        type="flex"
        align="center"
        justify="center"
        :lg="4"
        :sm="10"
        :xs="12"
      >
        <div class="v-list">
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                FIRST NAME:
              </div>
              <div class="sub-title">
                {{ checkout.firstName }}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                LAST NAME:
              </div>
              <div class="sub-title">
                {{ checkout.lastName }}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                EMAIL:
              </div>
              <div class="sub-title">
                {{ checkout.email }}
              </div>
            </div>
          </div>
          <div v-if="checkout.dob" class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                DATE OF BIRTH:
              </div>
              <div class="sub-title">
                {{getValue(checkout.dob)}}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                ADDRESS:
              </div>
              <div class="sub-title">
                {{checkout.address}}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                CITY:
              </div>
              <div class="sub-title">
                {{checkout.city}}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                STATE:
              </div>
              <div class="sub-title">
                {{checkout.state}}
              </div>
            </div>
          </div>
          <div class="vlist-item">
            <div class="list-tittles">
              <div class="title">
                ZIP CODE:
              </div>
              <div class="sub-title">
                {{checkout.zip}}
              </div>
            </div>
          </div>
          <div class="vlist-item" v-if="checkout.phone_number">
            <div class="list-tittles">
              <div class="title">
                PHONE NUMBER:
              </div>
              <div class="sub-title">
                {{checkout.phone_number}}
              </div>
            </div>
          </div>
          <div class="vlist-item" v-if="checkout.size">
            <div class="list-tittles">
              <div class="title">
                SIZE:
              </div>
              <div class="sub-title">
                {{checkout.size}}
              </div>
            </div>
          </div>

        </div>
      </vs-col>
    </vs-row>
    <vs-row align="center" justify="center">
      <vs-button id="btn-components-confirmation-back" square color="#89898b" size="large" @click="otherPrize">BACK</vs-button>
      <vs-button id="btn-components-confirmation-confirmmyprize" square color="#83bc00" size="large" @click="redeemPrize">{{contentCopies.confirm_btn_text}}</vs-button>
    </vs-row>
  </article>
</template>

<script>
const moment = require('moment')

export default {
  props: {
    promoName: {
      type: String,
      required: true,
    },
    prize: {
      type: Object,
      required: true,
    },
    checkout: {
      type: Object,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    logo:{
      type:String,
      require:false,
    },
    logo_url:{
      type:String,
      require:false
    },
    contentCopies: {
      type: Object,
      require: true,
    },
  },
  data: () => ({
    prize_size: '',
  }),
  methods: {
    redeemPrize() {
      const prizeSize = this.checkout.size.trim();
      if(prizeSize.length > 80) {
        this.$emit('error', 'Your size description is too long.', true, this.token);
        return;
      }
      const loading = this.$vs.loading({color:'#83bc00'});
      this.$http
        .post(`redeem/winners/redeemPrize?redeemToken=${this.token}`, {
          prize_id: this.prize.id,
          ...this.checkout,
          dob: this.checkout.dob ? this.checkout.dob : '1800-01-01',
        })
        .then(result => {
          loading.close();
          if (result.status === 200) {
            this.$emit('success', result.data);
          }
        })
        .catch((error) => {
          loading.close();
          this.$emit('error', this.getErrorMessage(error), true, this.token);
        });
    },
    otherPrize() {
      this.$emit('pickPrize');
    },
    getValue(checkout){
      return moment(checkout).format('MM/DD/YYYY')
    },
  },
};
</script>

<style lang="scss" scoped>
article {
  width: 100%;
}

.logo{
  max-width: 200px;
}

h1,
h2 {
  font-size: 48px;
  font-weight: 700;
  margin: 0.5rem 0;
  text-transform: uppercase;
}

h2 {
  color: #83bc00;
  width: 100%;
}

h3 {
  font-size: 24px;
  padding: 0.5rem 0;
  text-transform: capitalize;
}

ul {
  list-style: none;
  padding: 1rem;

  li {
    font-size: 1.2rem;
    font-weight: 500;
    text-align: justify;
    padding: 0.5rem;

    &:nth-child(2n + 1) {
      background: #ddd;
    }
  }
}
.v-list{
      width: 100%;
    position: relative;
    padding: 5px;
  .vlist-item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid rgba(0,0,0,.08);
    padding: 5px;
    .list-tittles{
      margin: 0;
      padding: 0;
      text-transform: none;
      text-decoration: none;
      display: inherit;
      width: 100%;
      .title{
        font-size: 15px;
        color: #5b5777;
        font-weight: 700;
        margin-right: 5px;
        width: 27%;
        text-align: left;
      }
      .sub-title{
        font-size: 15px;
        text-align: left;

      }
    }
  }
}

@media (max-width: 768px) {
    h1{
      font-size: 30px;
    }
    h2{
      font-size: 26px;
    }
    h3{
      font-size: 18px;
    }
    .list-tittles .sub-title{
      width: 100%;
      overflow: hidden;
    }
}
.article-confirmation{
  padding: 0 15px;
}

img {
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 90%;
  }
}
small {
  font-style: italic;
}
</style>
